type Props = {
    label: string;
};

export default function CategoryBadge({ label }: Props) {
    return (
        <span className="inline-flex rounded-full border border-[#e5ff00]/30 bg-[#e5ff00]/10 px-3 py-1 text-xs font-black uppercase tracking-[0.18em] text-[#e5ff00]">
      {label}
    </span>
    );
}